import React from 'react';
import KPISet from '../components/KPISet';
import List from './List';
import { Box } from '@mui/joy';
import JSONPretty from 'react-json-pretty';
import { useDrawer } from 'src/mtska-frontend-app-component';

const dataProviderName = 'partnershipDeals/ruleset';

const Default = () => {
    const defaultFilters = {
        items: [ ]
    };

    return <>
        <KPISet dataProviderName={dataProviderName} filters={defaultFilters} />
        <List filters={defaultFilters} />
    </>

}

export default Default;


